import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import AdminFooter from './AdminFooter';
import AdminSideMenu from './AdminSideMenu';

const AdminLayout: React.FC = () => {
  return (
    <div className="min-vh-100 bg-light d-flex flex-column admin-panel">
      <AdminHeader />
      <div className="container-fluid flex-grow-1 d-flex flex-column">
        <div className="row flex-grow-1">
          <AdminSideMenu />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 py-4">
            <Outlet />
          </main>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminLayout;
